import React from 'react'

const UserTypeContext = React.createContext({
  userType: '',
  setUserType: () => {},
})

export default UserTypeContext
